import {lazy} from "../../_snowpack/pkg/react.js";
import {generatePath} from "../../_snowpack/pkg/react-router-dom.js";
export const RsaSettingsRoute = {
  path: "/:realm/realm-settings/keys/providers/:id/rsa/settings",
  component: lazy(() => import("../key-providers/rsa/RSAForm.js")),
  breadcrumb: (t) => t("realm-settings:editProvider"),
  access: "view-realm"
};
export const toRsaSettings = (params) => ({
  pathname: generatePath(RsaSettingsRoute.path, params)
});
